import Slider from "../Slider"
import { getDealerId, getEquivalentGasMPG, getTooltips } from "../../../redux/selectors"
import { useDispatch, useSelector } from 'react-redux';
import { updateEquivalentGasMPG } from "../../../redux/Slices/userSlice";
import GaTracker from "../../../utils/GaTracker";

const SlideEquivalentGasMPG = ({type}) => {
    const dispatch = useDispatch()
    const equivalentGasMPG = useSelector(getEquivalentGasMPG)
    const dealerId = useSelector(getDealerId)
    const maxNumber = 80
    const tooltip = useSelector(getTooltips)

    const updateEquivalentGasEfficiency = (mpg) => {
        GaTracker.trackEvent({
          category: "Update",
          action: "Updated Equivalent Gas Efficiency",
          label: `Updated Equivalent Gas Efficiency Slider - ${dealerId}`,
        });

        if (!isNaN(Number(mpg))) {
            if (mpg > 80) {
                dispatch(updateEquivalentGasMPG(Number(maxNumber)))
            } else {
                dispatch(updateEquivalentGasMPG(Number(mpg)))
            }
        }
    }

    return (
        <Slider
            title={"Comparison MPG"}
            value={equivalentGasMPG}
            onChange={updateEquivalentGasEfficiency}
            min={5}
            max={maxNumber}
            step={5}
            maxLength={2}
            tooltip={tooltip?.mpgTip}
            tooltipPlacement="top"
        />
    )
}

export default SlideEquivalentGasMPG
